import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Button } from '../main/Styles/Toolbar.jsx';
import { CONNECTION_STATE } from './StateConstants.jsx';
import { DEVICE_URL } from '../../imports/ec9xns/ec9xns-connection.js';

// 🟦 LinkButton con PropTypes y opción de "download"
const LinkButton = ({ href, children, newTab = false, download = false }) => {
  const commonStyle = {
    display: 'inline-block',
    padding: '10px 16px',
    border: 0,
    borderRadius: '6px',
    background: '#1976d2',
    color: '#fff',
    textDecoration: 'none',
    font: '600 14px/1.2 system-ui',
    cursor: 'pointer',
  };

  const target = newTab ? '_blank' : undefined;
  const rel = newTab ? 'noopener noreferrer' : undefined;

  return (
    <a href={href} target={target} rel={rel} style={commonStyle} {...(download ? { download: '' } : {})}>
      {children}
    </a>
  );
};

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  newTab: PropTypes.bool,
  download: PropTypes.bool,
};

const RedirectDashboardStep = (props) => {
  const onClickRedirect = () => {
    const url = `${props.deviceURL}/#refadmin`;
    console.log(`Dashboard url: ${url}`);

    const nextState =
      props.deviceURL === DEVICE_URL.HTTP_IP_8080
        ? CONNECTION_STATE.ASKING_DOWNLOAD_ROOT_CERT
        : CONNECTION_STATE.UPDATE_IN_DASHBOARD;

    props.setState(nextState);

    // Abrir Dashboard en nueva pestaña con aislamiento
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Fragment>
      <div>
        <p>
          <b>
            Your browser requires a security certificate to connect to your scanner.
            Please follow the 3-step process to install the Root Certificate and then check for updates.
          </b>
        </p>

        {/* 🟦 Usar <ol> y márgenes en vez de <br/> */}
        <ol style={{ listStyle: 'none', margin: '0.5rem 0 0 1.25rem' }}>
          <li style={{ marginBottom: '1rem' }}>
            <b>Step #1:</b>{' '}
            <LinkButton
              href="https://testscannerupdate.rdmcorp.com/PROD-2025/Root-Certificates-2025/RDM-NW-Scanner-Setup.exe"
              newTab
              download
            >
              Download Root Certificate for Windows
            </LinkButton>
          </li>

          <li style={{ listStyle: 'none', marginBottom: '1rem' }}>
            <b>Step #2:</b>{' '}
            <LinkButton
              href="https://testscannerupdate.rdmcorp.com/PROD-2025/Documents/RDM_Root_Certificate_Installation_Guide_Windows-SSWP.pdf"
              newTab
            >
              📘 View Windows Installation Guide
            </LinkButton> <span> Install the Root Certificate (<i>Admin rights required</i>).</span>

          </li>

          <li style={{ listStyle: 'none',  marginBottom: '1rem' }}>
            <b>Step #3:</b>{' '}
            <LinkButton href="./SSWP-2/">
              Check for Firmware Updates
            </LinkButton>
          </li>
        </ol>

      
      </div>
    </Fragment>
  );
};

RedirectDashboardStep.propTypes = {
  setState: PropTypes.func.isRequired,
  deviceURL: PropTypes.string.isRequired,
};

export default RedirectDashboardStep;
